export default "__VITE_ASSET__DQPjME9z__"